module.exports = "/_next/static/images/Trend04Visual@2x-05011718f08b7c27cc230ffae495e803.webp";